import { createSlice } from "@reduxjs/toolkit";
import { initialState, unlikeThunk } from "./likeUnlikeSlice";
export const unlikeSlice = createSlice({
  name: "unlike",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  extraReducers: (builder) => {
    builder
      .addCase(unlikeThunk.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(unlikeThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        // console.log(action.payload);
        state.isError = false;
        state.unlikes = action.payload;
      })
      .addCase(unlikeThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.unlikes = 0;
        state.isError = true;
        state.error = action.error?.message;
      });
  },
});
export default unlikeSlice.reducer;
